import { render, staticRenderFns } from "./MoveTransactionToSaving.vue?vue&type=template&id=01575216&scoped=true"
import script from "./MoveTransactionToSaving.vue?vue&type=script&lang=js"
export * from "./MoveTransactionToSaving.vue?vue&type=script&lang=js"
import style0 from "./MoveTransactionToSaving.vue?vue&type=style&index=0&id=01575216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01575216",
  null
  
)

export default component.exports